import { IAdvancedFormSection } from '~shared/modules/advanced-form/models/advanced-form.model';

export const DEFAULT_DELAY_BEFORE_REDIRECT_IF_EMAIL_EXIST = '3500';

export const EMAIL_FIELD_VALIDATION_CONFIG = {
  name: 'email',
  label: 'REGULAR.FIELDS.EMAIL.LABEL',
  placeholder: 'REGULAR.FIELDS.EMAIL.PLACEHOLDER',
  submitText: 'REGULAR.CONTINUE',
  hintText: 'PAGES.AUTH.REGISTRATION.VALIDATION.EMAIL_EXISTS',
  hintToggle: false,
  noSpaces: true,
};

export const ALREADY_IN_USE_TEXT = 'is already in use';

export const FORM_SECTION_LIST_WITH_EMAIL_VARIANT: IAdvancedFormSection[] = [
  {
    fieldList: [EMAIL_FIELD_VALIDATION_CONFIG],
  },
];

export const ENABLED_EXPERIMENT = 'enabled';
export const FF_ENABLE_AUTH_URL_FROM_HOME_PAGE = 'FF_ENABLE_AUTH_URL_FROM_HOME_PAGE';
